import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import PrecacheImg from "../../../../utils/PrecacheImage";
import {
  withCartIdParam,
  addParamToURL
} from "../../../../utils/BrowserHelper";
import Telemetry from "../../../../utils/rudderstackAnalytics";
import LightBoxImage from "./LightBoxImage";
import keydown from "react-keydown";
import Swipeable from "react-swipeable";
import ajax from "superagent";
import LightBoxVideo from "./LightBoxVideo";
import { Album as AlbumType, Event } from "../types";
import TagsSection from "./TagsSections";
import ISOToDateTimeFormat from "../../../../utils/ISOToDateTimeFormat";
import CollectCustomerEmailModal from "../CollectCustomerEmailModal";
import DownloadWithEmailModal from "./DownloadWithEmailModal";
import LightBoxFooterActions from "./LightboxFooterActions";
import EventNameLink from "./EventNameLink";
import toastr from "../../../common/toastr";
import LightBoxPrintProducts from "./LightBoxPrintProducts";

interface LightBoxContext {
  prepaidCustomer?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    eventId?: number;
  };
  cartId?: number;
  isEmbed?: boolean;
  userId?: number;
  pageConfiguration?: {
    primaryColor?: string;
    secondaryColor?: string;
    accentColor?: string;
  };
  arePrepaidPhotosAvailable?: any;
  organizationId?: number;
  canManageTags?: boolean;
  reLoadAlbumPhotos?: () => void;
  curationMode?: boolean;
  isAuthorizedForDirectDownloads?: boolean;
  addPhotoToFavoritesAPI?: string;
  removePhotoFromFavoritesAPI?: string;
  guestUserId?: number;
  setGuestUserCart?: (userId: number, userEmail: string, cart: any) => void;
  setGuestUser?: (userId: number, userEmail: string) => void;
  registerGuestUserAPI?: string;
  cartPrepaidPhotos?: any[];
  hidePhotographersFilter?: boolean;
  securedGalleryView?: boolean;
  directDownloadEnabled?: boolean;
  endUserDownloadsDisabled?: boolean;
  canShowEmailPopup: () => boolean;
  showSaveCartModalWithItem: (photo: any, cartItem: any) => void;
  cookiePrepaidAvailed?: boolean;
  cookiePrepaidPhotosAvailed?: number;
}

interface LightBoxProps {
  photos: any;
  photoIndex: number;
  showLightBox: (photoIndex: number) => void;
  closeLightBox: () => void;
  cartHasPhotos?: boolean;
  addToCart: (photo: any) => void;
  removeFromCart: (photo: any) => void;
  event: Event;
  album: AlbumType;
  eventClickable?: boolean;
  cart?: any;
  isAuthorizedForDirectDownloads?: boolean;
  primaryColor?: string;
  userId?: number;
  isEmbed?: boolean;
  photoSaved?: boolean;
  curationApiCalled?: boolean;
  setCurationApiCalled: (state: boolean) => void;
  trackTelemetry?: boolean;
  parentName: string;
  showFavIcon?: boolean;
  registerGuestUserAPI: string;
  securedGalleryView: boolean;
  setGuestUserId: (userId: number) => void;
  secureAccessToken?: string;
  directDownloadEnabled?: boolean;
  endUserDownloadsDisabled?: boolean;
  updateCartFromApiResponse?: (apiResponse: any) => void;
  setSelfieUploadPopup?: (value: boolean) => void;
}

interface LightBoxState {
  photo: any;
  photoSaved: boolean;
  isFavorite: boolean;
  addTags: boolean;
  mediaTags: Array<{ name: string; tagId: number; taggableType: string }>;
  loading: boolean;
  defaultHidden: boolean;
  showEmailCollectModal: boolean;
  showDownloadWithEmailModal: boolean;
  hasCartItems: boolean;
}

class LightBox extends React.Component<LightBoxProps, LightBoxState> {
  context!: LightBoxContext;

  static contextTypes = {
    prepaidCustomer: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      eventId: PropTypes.number
    }),
    cartId: PropTypes.number,
    isEmbed: PropTypes.bool,
    userId: PropTypes.number,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string,
      secondaryColor: PropTypes.string,
      accentColor: PropTypes.string
    }),
    arePrepaidPhotosAvailable: PropTypes.any,
    organizationId: PropTypes.number,
    canManageTags: PropTypes.bool,
    reLoadAlbumPhotos: PropTypes.func,
    curationMode: PropTypes.bool,
    isAuthorizedForDirectDownloads: PropTypes.bool,
    addPhotoToFavoritesAPI: PropTypes.string,
    removePhotoFromFavoritesAPI: PropTypes.string,
    guestUserId: PropTypes.number,
    setGuestUserCart: PropTypes.func,
    setGuestUser: PropTypes.func,
    registerGuestUserAPI: PropTypes.string,
    canShowEmailPopup: PropTypes.func,
    showSaveCartModalWithItem: PropTypes.func,
    endUserDownloadsDisabled: PropTypes.bool,
    cookiePrepaidAvailed: PropTypes.bool,
    cookiePrepaidPhotosAvailed: PropTypes.number,
    cartPrepaidPhotos: PropTypes.array
  };

  constructor(props: LightBoxProps) {
    super(props);

    this.state = {
      photo: this.props.photos[this.props.photoIndex],
      photoSaved: false,
      addTags: false,
      mediaTags: [],
      loading: true,
      defaultHidden: this.props.photos[this.props.photoIndex].hidden,
      isFavorite: false,
      showEmailCollectModal: false,
      showDownloadWithEmailModal: false,
      hasCartItems: false
    };
  }

  canDownloadPhotos = () =>
    this.props.isAuthorizedForDirectDownloads ||
    this.context.isAuthorizedForDirectDownloads;

  componentDidMount() {
    this.canDownloadPhotos() && this.verifyPhotoSaved();
    if (this.context.curationMode) {
      this.verifyPhotoHidden();
    }
    if (this.context.canManageTags) {
      this.getTags();
    } else {
      this.setState({ loading: false });
    }
    if (this.context.guestUserId || this.context.userId)
      this.verifyPhotoFavorited();
  }

  shouldComponentUpdate(
    nextProps: { photos: { [x: string]: any }; photoIndex: string | number; cart?: any },
    nextState: {
      photoSaved: boolean;
      loading: boolean;
      defaultHidden: boolean;
      isFavorite: boolean;
      showEmailCollectModal: boolean;
      showDownloadWithEmailModal: boolean;
      hasCartItems: boolean;
    }
  ) {
    if (
      this.state.photo != nextProps.photos[nextProps.photoIndex] ||
      this.state.photoSaved != nextState.photoSaved ||
      this.state.loading != nextState.loading ||
      this.state.defaultHidden != nextState.defaultHidden ||
      this.state.isFavorite != nextState.isFavorite ||
      this.state.showEmailCollectModal != nextState.showEmailCollectModal ||
      this.state.showDownloadWithEmailModal !=
        nextState.showDownloadWithEmailModal ||
      this.state.hasCartItems !== nextState.hasCartItems ||
      this.props.cart !== nextProps.cart
    ) {
      return true;
    } else return false;
  }

  componentDidUpdate() {
    if (this.state.photo === this.props.photos[this.props.photoIndex]) {
      this.setState({ photo: this.props.photos[this.props.photoIndex] });
    }
  }

  setHiddenState = (val: boolean) => this.setState({ defaultHidden: val });

  verifyPhotoHidden = () =>
    ajax
      .get(
        `/api/v1/photos/${
          this.props.photos[this.props.photoIndex].id
        }/is_hidden?user_id=${this.context.userId || this.props.userId}`
      )
      .then(response => {
        this.setState({ defaultHidden: response.body.is_hidden });
      });

  verifyPhotoSaved = () =>
    ajax
      .get(
        `/api/v1/photos/${
          this.props.photos[this.props.photoIndex].id
        }/is_saved?user_id=${this.context.userId || this.props.userId}`
      )
      .then(response => {
        this.setState({ photoSaved: response.body.is_saved });
      });

  verifyPhotoFavorited = () =>
    ajax
      .get(
        `/api/v1/photos/${
          this.props.photos[this.props.photoIndex].id
        }/is_liked?user_id=${this.context.userId || this.context.guestUserId}`
      )
      .then(response => {
        this.setState({ isFavorite: response.body.is_liked });
      });

  onClickFavoriteIcon = ({
    isFavorite,
    source
  }: {
    id: number;
    isFavorite: boolean;
    source: string;
  }) => {
    this.setState({ isFavorite: isFavorite }, () => {
      if (this.context.userId) {
        this.handleFavoritesSelection({
          userId: this.context.userId
        });
      } else if (this.context.guestUserId) {
        this.handleFavoritesSelection({
          userId: this.context.guestUserId
        });
      } else {
        this.handleEmailCollectModal();
      }
    });
  };

  // Function to toggle the showEmailCollectModal state
  handleEmailCollectModal = () => {
    this.setState(
      { showEmailCollectModal: !this.state.showEmailCollectModal },
      () => {
        if (this.state.showEmailCollectModal) {
          Telemetry.track("event-gallery:guest-favorites-email-prompted", {
            eventId: this.props.event.id,
            eventName: this.props.event.name,
            photoId: this.state.photo.id,
            source: this.state.photo.source
          });
        }
      }
    );
  };

  addToFavorites = ({
    userId,
    userEmail,
    cart
  }: {
    userId: number;
    userEmail: string;
    cart: any;
  }) => {
    const requestBody = {
      user_id: userId,
      photo_id: this.state.photo.id
    };
    fetch(this.context.addPhotoToFavoritesAPI, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => {
        if (!response.ok) {
          this.context.setGuestUserCart(userId, userEmail, cart);
          this.trackAddToFavorite();
          throw new Error("Already added to favorites");
        }
        return true;
      })
      .then(res => {
        this.context.setGuestUserCart(userId, userEmail, cart);
        this.trackAddToFavorite();
      })
      .catch(error => {
        const errorMessage = error.message.replace("Error: ", "");
        //@ts-ignore
        toastr.error(errorMessage);
      });
  };

  handleFavoritesSelection = ({ userId }: { userId: number }) => {
    const requestBody = {
      user_id: userId,
      photo_id: this.state.photo.id
    };

    if (this.state.isFavorite) {
      fetch(this.context.removePhotoFromFavoritesAPI, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          this.setState({ isFavorite: false });
        })
        .catch(error => {
          //@ts-ignore
          toastr.error(error.response.body.error);
        });
    } else {
      fetch(this.context.addPhotoToFavoritesAPI, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          this.trackAddToFavorite();
          this.setState({ isFavorite: true });
        })
        .catch(error => {
          //@ts-ignore
          toastr.error(error);
        });
    }
  };

  trackAddToFavorite = () => {
    Telemetry.track("event-gallery:add-to-favorites", {
      eventId: this.props.event.id,
      eventName: this.props.event.name,
      photoId: this.state.photo.id,
      source: this.state.photo.source
    });
  };

  handleSave = () => {
    ajax
      .post(
        addParamToURL(
          withCartIdParam(
            `/api/v1/photos/${this.state.photo.id}/save`,
            this.cartId(),
            this.isEmbed()
          ),
          "user_id",
          this.context.userId || this.props.userId
        )
      )
      .then(res => {
        this.setState({ photoSaved: true }, () =>
          //@ts-ignore
          toastr.success("Photo saved", null, { timeOut: 1000 })
        );

        return true;
      });
  };

  getTags = () => {
    ajax
      .get(
        `/api/v1/content_tags/${this.props.photos[this.props.photoIndex].id}`
      )
      .then(response =>
        this.setState({ mediaTags: response.body.appliedTags, loading: false })
      )
      .catch(error => {
        // @ts-ignore
        toastr.error("There was an error loading tags");
        console.error(error);
        this.setState({ loading: false });
      });
  };

  handleUnsave = () => {
    ajax
      .delete(
        addParamToURL(
          withCartIdParam(
            `/api/v1/photos/${this.state.photo.id}/unsave`,
            this.cartId()
          ),
          "user_id",
          this.context.userId || this.props.userId
        )
      )
      .then(res => {
        this.setState({ photoSaved: false }, () =>
          //@ts-ignore
          toastr.success("Photo unsaved", null, { timeOut: 1000 })
        );

        return true;
      });
  };

  componentWillMount() {
    document.getElementsByTagName("body")[0].classList.add("modal-open");
  }

  componentWillUnmount() {
    document.getElementsByTagName("body")[0].classList.remove("modal-open");
  }

  @keydown("left", "right", "esc")
  submit(event: { which: number }) {
    if (event.which == 37 && this.hasPrevImage()) this.prevImage();
    else if (event.which == 39 && this.hasNextImage()) this.nextImage();
    else if (event.which == 27) this.props.closeLightBox();
  }

  componentWillReceiveProps(nextProps: {
    photos: { [x: string]: any };
    photoIndex: string | number;
  }) {
    this.setState({
      photo: nextProps.photos[nextProps.photoIndex]
    });
  }

  // returns next three photos' watermarked & zoom versions
  // as an array
  imagesToPrefetch = () =>
    _.compact(
      _.flatten(
        _.slice(
          this.props.photos,
          this.props.photoIndex,
          this.props.photoIndex + 3
        ).map((photo: any) => {
          return [photo.watermarkedImg, photo.zoomImg];
        })
      )
    );

  prevImage = async (e?: any) => {
    if (e) e.preventDefault();
    this.resetLightBoxImage(this.props.photoIndex - 1);
    if (this.context.curationMode) {
      this.verifyPhotoHidden();
    }
  };

  nextImage = async (e?: any) => {
    if (e) e.preventDefault();
    this.resetLightBoxImage(this.props.photoIndex + 1);
    if (this.context.curationMode) {
      this.verifyPhotoHidden();
    }
  };

  resetLightBoxImage = (photoIndex: number) => {
    this.props.showLightBox(photoIndex);
  };

  hasPrevImage = () => {
    return this.props.photos[this.props.photoIndex - 1] != undefined;
  };

  hasNextImage = () => {
    return this.props.photos[this.props.photoIndex + 1] != undefined;
  };

  leftArrow = () => {
    return (
      <a className="left carousel-control" onClick={this.prevImage}>
        <span className="fa fa-angle-left" />
      </a>
    );
  };

  rightArrow = () => {
    return (
      <a className="right carousel-control" onClick={this.nextImage}>
        <span className="fa fa-angle-right" />
      </a>
    );
  };

  cartId = () => this.context.cartId || this.props.cart?.id;
  isEmbed = () => this.context.isEmbed || this.props.isEmbed;

  handleCloseLightBox = () => (
    this.props.curationApiCalled && this.props.setCurationApiCalled(false),
    this.props.closeLightBox(),
    this.context.curationMode &&
      this.props.curationApiCalled &&
      this.context.reLoadAlbumPhotos()
  );

  handleDownloadEmailModal = () => {
    this.setState(prevState => ({
      showDownloadWithEmailModal: !prevState.showDownloadWithEmailModal
    }));
  };

  curatePhoto = async () => {
    const hiddenVal = this.props.curationApiCalled
      ? this.state.defaultHidden
      : this.state.photo.hidden;
    const action = hiddenVal == true ? "unhide" : "hide";
    try {
      const res = await $.ajax({
        url: `/api/v1/photos/${action}`,
        type: "POST",
        data: {
          photo_ids: [this.state.photo.id],
          event_id: this.props.event.id
        }
      });

      //@ts-ignore
      toastr.success("Successfully updated");
      this.setState({
        defaultHidden: !hiddenVal
      });
    } catch (err) {
      //@ts-ignore
      toastr.error("Failed to update");
      console.error(err);
    }
  };

  trackGuestFavoriteProvidedEmail = () => {
    Telemetry.track("event-gallery:guest-favorites-provided-email", {
      eventId: this.props.event.id,
      eventName: this.props.event.name,
      photoId: this.state.photo.id,
      source: this.state.photo.source
    });
  };

  setGuestUser = (userId: number, userEmail: string) => {
    this.context.setGuestUser?.(userId, userEmail);
    //For OrganizationEvent
    this.props.setGuestUserId?.(userId);
    const downloadUrl = `/end_user_content_downloads?photo_ids=${
      this.state.photo.id
    }${userId ? `&user_id=${userId}` : ""}`;
    try {
      window.location.href = downloadUrl;
    } catch (error) {
      console.error("Failed to navigate to download URL", error);
      toastr.error("Failed to navigate to download URL. Please try again.");
    }
  };

  handleCartStatusChange = (hasCartItems: boolean) => {
    this.setState({ hasCartItems });
  };

  render() {
    return (
      <span>
        <div className="modal fade in ns" id="modal-mygallery">
          {" "}
          {this.state.loading ? (
            <div>loading...</div>
          ) : (
            <Swipeable
              onSwipedLeft={this.nextImage}
              onSwipedRight={this.prevImage}
            >
              <div
                className={`modal-dialog ${
                  this.props.event.hasPrintProducts
                    ? "lightbox-extended"
                    : "lightbox-no-print"
                }`}
                role="document"
              >
                <div className="lightbox-extend-inner">
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => this.handleCloseLightBox()}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="lightbox-main-content">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="modal-mygallery-ttl">
                          <div className="hidden-xs">
                            <LightBoxHeader
                              event={this.props.event}
                              album={this.props.album}
                              photo={this.state.photo}
                              eventClickable={this.props.eventClickable}
                              cartId={this.cartId()}
                              isEmbed={this.isEmbed()}
                              secureAccessToken={this.props.secureAccessToken}
                            />
                          </div>
                          <div className="mobile-header visible-xs-block">
                            <LightBoxFooter
                              event={this.props.event}
                              album={this.props.album}
                              photo={this.state.photo}
                              photoHidden={this.state.defaultHidden}
                              cartHasPhotos={this.state.hasCartItems}
                              addToCart={this.props.addToCart}
                              removeFromCart={this.props.removeFromCart}
                              cartId={this.cartId()}
                              isEmbed={this.isEmbed()}
                              primaryColor={
                                this.props.primaryColor ||
                                this.context.pageConfiguration?.primaryColor ||
                                "#259fa5"
                              }
                              userId={this.props.userId}
                              photoSaved={this.state.photoSaved}
                              handleSave={this.handleSave}
                              handleUnsave={this.handleUnsave}
                              setHiddenState={this.setHiddenState}
                              setCurationApiCalled={
                                this.props.setCurationApiCalled
                              }
                              curatePhoto={this.curatePhoto}
                              trackTelemetry={this.props.trackTelemetry}
                              parentName={this.props.parentName}
                              handleDownloadEmailModal={
                                this.handleDownloadEmailModal
                              }
                              securedGalleryView={
                                this.context.securedGalleryView ||
                                this.props.securedGalleryView
                              }
                              secureAccessToken={this.props.secureAccessToken}
                              directDownloadEnabled={
                                this.props.directDownloadEnabled ||
                                this.context.directDownloadEnabled
                              }
                              endUserDownloadsDisabled={
                                this.props.endUserDownloadsDisabled ||
                                this.context.endUserDownloadsDisabled
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-body">
                        {this.state.photo.videoContent ? (
                          <LightBoxVideo
                            video={this.state.photo}
                            hidden={this.state.defaultHidden}
                            //@ts-ignore
                            event={this.props.event}
                            onClickFavoriteIcon={this.onClickFavoriteIcon}
                            showFavIcon={this.props.showFavIcon}
                            isFavorite={this.state.isFavorite}
                          />
                        ) : (
                          <LightBoxImage
                            photo={this.state.photo}
                            hidden={this.state.defaultHidden}
                            //@ts-ignore
                            event={this.props.event}
                            onClickFavoriteIcon={this.onClickFavoriteIcon}
                            showFavIcon={this.props.showFavIcon}
                            isFavorite={this.state.isFavorite}
                          />
                        )}
                        {this.props.event.hasPrintProducts &&
                          this.state.photo.fileName && (
                            <p
                              className="modal-file-name"
                              style={{ height: 40 }}
                            >
                              {this.state.photo.fileName}
                            </p>
                          )}
                      </div>
                      {!this.props.event.hasPrintProducts && (
                        <div className="modal-footer hidden-xs">
                          <LightBoxFooter
                            event={this.props.event}
                            album={this.props.album}
                            photo={this.state.photo}
                            photoHidden={this.state.defaultHidden}
                            cartHasPhotos={this.state.hasCartItems}
                            addToCart={this.props.addToCart}
                            removeFromCart={this.props.removeFromCart}
                            cartId={this.cartId()}
                            isEmbed={this.isEmbed()}
                            isAuthorizedForDirectDownloads={
                              this.props.isAuthorizedForDirectDownloads
                            }
                            primaryColor={
                              this.props.primaryColor ||
                              this.context.pageConfiguration?.primaryColor ||
                              "#259fa5"
                            }
                            userId={this.props.userId}
                            photoSaved={this.state.photoSaved}
                            handleSave={this.handleSave}
                            handleUnsave={this.handleUnsave}
                            setHiddenState={this.setHiddenState}
                            setCurationApiCalled={this.props.setCurationApiCalled}
                            curatePhoto={this.curatePhoto}
                            trackTelemetry={this.props.trackTelemetry}
                            parentName={this.props.parentName}
                            handleDownloadEmailModal={
                              this.handleDownloadEmailModal
                            }
                            securedGalleryView={this.props.securedGalleryView}
                            directDownloadEnabled={
                              this.props.directDownloadEnabled ||
                              this.context.directDownloadEnabled
                            }
                            endUserDownloadsDisabled={
                              this.props.endUserDownloadsDisabled ||
                              this.context.endUserDownloadsDisabled
                            }
                          />
                        </div>
                      )}
                      {this.context.canManageTags &&
                        !this.props.event.hasPrintProducts && (
                          <TagsSection
                            colorStyling={
                              this.props.primaryColor ||
                              this.context.pageConfiguration?.primaryColor ||
                              "#259fa5"
                            }
                            appliedTags={this.state.mediaTags}
                            photoId={[this.state.photo.id]}
                            contentTagsAPI={"/api/v1/content_tags"}
                          />
                        )}
                    </div>
                  </div>
                  {this.props.event.hasPrintProducts && (
                      <div className="lightbox-print-products-section">
                        <LightBoxPrintProducts
                          photo={this.state.photo}
                          event={this.props.event}
                          cartId={this.cartId()}
                          cart={this.props.cart}
                          primaryColor={
                            this.props.primaryColor ||
                            this.context.pageConfiguration?.primaryColor ||
                            "#259fa5"
                          }
                          updateCartFromApiResponse={
                            this.props.updateCartFromApiResponse
                          }
                          setSelfieUploadPopup={this.props.setSelfieUploadPopup}
                          onCartStatusChange={this.handleCartStatusChange}
                          canShowEmailPopup={this.context.canShowEmailPopup}
                          showSaveCartModal={
                            this.context.showSaveCartModalWithItem
                          }
                          isEmbed={this.isEmbed()}
                          isPrepaidActive={!!(
                            (this.context.arePrepaidPhotosAvailable
                              ? this.context.arePrepaidPhotosAvailable()
                              : false) ||
                            _.includes(this.context.cartPrepaidPhotos, this.state.photo.id) ||
                            (this.props.event.prepaidCustomersPrimaryAuthField === "cookie" &&
                              this.props.event.prepaidCustomersEnabled &&
                              !this.context.cookiePrepaidAvailed &&
                              (!this.props.event.prepaidCustomersHardLimitEnabled ||
                                ((this.context.cartPrepaidPhotos || []).length +
                                  (this.context.cookiePrepaidPhotosAvailed || 0)) <
                                  this.props.event.prepaidCustomersPhotoLimit))
                          )}
                        />
                      </div>
                    )}
                </div>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="geo-report__btn"
                  href={this.state.photo.reportPhotoPath}
                >
                  <i className="fa fa-flag"></i>
                  <u>Report Content</u>
                </a>
              </div>
            </Swipeable>
          )}
          {this.hasPrevImage() ? this.leftArrow() : null}
          {this.hasNextImage() ? this.rightArrow() : null}
          <PrecacheImg images={this.imagesToPrefetch()} />
        </div>
        <div className="modal-backdrop fade in" />
        {this.state.showEmailCollectModal ? (
          <CollectCustomerEmailModal
            closeModal={this.handleEmailCollectModal}
            registerGuestUserAPI={this.context.registerGuestUserAPI}
            addToFavorites={this.addToFavorites}
            eventId={this.props.event.id}
            trackGuestFavoriteProvidedEmail={
              this.trackGuestFavoriteProvidedEmail
            }
          />
        ) : null}
        {this.state.showDownloadWithEmailModal ? (
          <DownloadWithEmailModal
            closeModal={this.handleDownloadEmailModal}
            registerGuestUserAPI={
              this.context.registerGuestUserAPI ||
              this.props.registerGuestUserAPI
            }
            eventId={this.props.event.id}
            setGuestUser={(userId: number, userEmail: string) => {
              this.setGuestUser(userId, userEmail);
            }}
          />
        ) : null}
      </span>
    );
  }
}

export default LightBox;

interface LightBoxFooterProps {
  event: Event;
  album: AlbumType;
  photo: any;
  cartHasPhotos?: boolean;
  addToCart: (photo: any) => void;
  removeFromCart: (photo: any) => void;
  cartId: number | null;
  isEmbed: boolean;
  isAuthorizedForDirectDownloads?: boolean;
  primaryColor: string;
  userId?: number;
  photoSaved: any;
  handleSave?: () => void;
  handleUnsave?: () => void;
  photoHidden: boolean;
  setHiddenState: (val: boolean) => void;
  curatePhoto: () => void;
  setCurationApiCalled: (state: boolean) => void;
  trackTelemetry?: boolean;
  parentName?: string;
  handleDownloadEmailModal: () => void;
  securedGalleryView: boolean;
  secureAccessToken?: string;
  directDownloadEnabled?: boolean;
  endUserDownloadsDisabled?: boolean;
}
class LightBoxFooter extends React.Component<LightBoxFooterProps> {
  context!: LightBoxContext;

  static contextTypes = {
    isAuthorizedForDirectDownloads: PropTypes.bool,
    prepaidCustomer: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      eventId: PropTypes.number
    }),
    canManageTags: PropTypes.bool,
    cartPrepaidPhotos: PropTypes.array,
    arePrepaidPhotosAvailable: PropTypes.any,
    cartId: PropTypes.number,
    isEmbed: PropTypes.bool,
    userId: PropTypes.number,
    pageConfiguration: PropTypes.shape({
      primaryColor: PropTypes.string,
      secondaryColor: PropTypes.string,
      accentColor: PropTypes.string
    }),
    curationMode: PropTypes.bool,
    guestUserId: PropTypes.number,
    securedGalleryView: PropTypes.bool,
    directDownloadEnabled: PropTypes.bool,
    endUserDownloadsDisabled: PropTypes.bool
  };

  cartId = () => this.context.cartId || this.props.cart?.id;
  isEmbed = () => this.context.isEmbed || this.props.isEmbed;
  canDownloadPhotos = () =>
    this.props.isAuthorizedForDirectDownloads ||
    this.context.isAuthorizedForDirectDownloads;

  freeEvent = () => this.props.event.price == 0;

  isPrepaid = () =>
    (this.context.arePrepaidPhotosAvailable
      ? this.context.arePrepaidPhotosAvailable()
      : false) ||
    _.includes(this.context.cartPrepaidPhotos, this.props.photo.id);

  handleHideTooltip = () =>
    //@ts-ignore
    $('#save-tooltip [data-toggle="tooltip"]').tooltip();

  handleToggle = (id: string, msg: string) =>
    $(`#${id} [data-toggle="tooltip"]`)
      .attr("data-original-title", `${msg}`)
      //@ts-ignore
      .tooltip("show");

  toggleSave = () =>
    this.props.photoSaved
      ? (this.props.handleUnsave?.(),
        $('#save-tooltip [data-toggle="tooltip"]')
          .attr("data-original-title", "Save for later")
          //@ts-ignore
          .tooltip("show"))
      : (this.props.handleSave?.(),
        //@ts-ignore
        $('#save-tooltip [data-toggle="tooltip"]').tooltip("hide"));

  handlePhotoNameTooltip = () =>
    //@ts-ignore
    $(".geo-lt__photoname").tooltip();

  isGallerySecured = () => {
    const userId =
      this.context.userId || this.context.guestUserId || this.props.userId;
    return (
      userId || this.context.securedGalleryView || this.props.securedGalleryView
    );
  };

  render() {
    const userId =
      this.context?.guestUserId || this.context?.userId || this.props.userId;

    const href = `/end_user_content_downloads?photo_ids=${this.props.photo.id}${
      userId ? `&user_id=${userId}` : ""
    }`;

    return (
      <LightBoxFooterActions
        cartHasPhotos={this.props.cartHasPhotos || false}
        freeEvent={this.freeEvent() || false}
        parentName={this.props.parentName || ""}
        cartId={this.cartId()}
        primaryColor={this.props.primaryColor || ""}
        userId={
          this.context.userId ||
          this.context.guestUserId ||
          this.props.userId ||
          null
        }
        href={href}
        photo={this.props.photo}
        addToCart={this.props.addToCart}
        removeFromCart={this.props.removeFromCart}
        handleDownloadEmailModal={this.props.handleDownloadEmailModal}
        curationMode={this.context.curationMode}
        photoHidden={this.props.photoHidden}
        curatePhoto={this.props.curatePhoto}
        setCurationApiCalled={this.props.setCurationApiCalled}
        photoSaved={this.props.photoSaved}
        handleSave={this.props.handleSave || (() => {})}
        handleUnsave={this.props.handleUnsave || (() => {})}
        handleToggle={this.handleToggle}
        handleHideTooltip={this.handleHideTooltip}
        canDownloadPhotos={this.canDownloadPhotos()}
        isEmbed={this.isEmbed()}
        eventData={this.props.event}
        isPrepaid={this.isPrepaid()}
        securedGalleryView={
          this.props.securedGalleryView || this.context.securedGalleryView
        }
        directDownloadEnabled={
          this.props.directDownloadEnabled || this.context.directDownloadEnabled
        }
        endUserDownloadsDisabled={
          this.props.endUserDownloadsDisabled || this.context.endUserDownloadsDisabled
        }
      />
    );
  }
}

interface LightBoxHeaderProps {
  event: Event;
  album: AlbumType;
  photo: any;
  eventClickable?: boolean;
  cartId: number;
  isEmbed: Function;
  secureAccessToken?: string;
}

class LightBoxHeader extends React.Component<LightBoxHeaderProps> {
  context!: LightBoxContext;

  static contextTypes = {
    cartId: PropTypes.number,
    isEmbed: PropTypes.bool,
    hidePhotographersFilter: PropTypes.bool
  };

  cartId = () => this.context.cartId || this.props.cart?.id;
  isEmbed = () => this.context.isEmbed || this.props.isEmbed;
  hidePhotographersFilter = () =>
    this.context.hidePhotographersFilter ||
    this.props.photo.hidePhotographersFilter;

  render() {
    return (
      <div className="dv-imgdetails-text">
        <EventNameLink
          event={this.props.event}
          eventClickable={this.props.eventClickable || false}
          isEmbed={this.isEmbed()}
          cartId={this.cartId()}
          secureAccessToken={this.props.secureAccessToken || ""}
        />
        <h4>{this.props.album.name}</h4>
        <div className="geo-report__wrap d-flex geo-jcb geo-ac">
          <p>
            {!this.hidePhotographersFilter() && (
              <>
                {this.props.album.photographerName}{" "}
                {this.props.photo.dateTimeTaken && "•"}
              </>
            )}
            <p style={{ textTransform: "none" }}>
              {this.props.photo.dateTimeTaken
                ? ` ${ISOToDateTimeFormat(this.props.photo.dateTimeTaken)}`
                : ""}
            </p>
          </p>
        </div>
      </div>
    );
  }
}
